"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resendActivationSchema = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Icon_1 = __importDefault(require("@material-ui/core/Icon"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var styles_1 = require("@material-ui/core/styles");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var yup = __importStar(require("yup"));
var colors_1 = __importDefault(require("../../../../assets/jss/colors"));
var material_kit_pro_react_1 = require("../../../../assets/jss/material-kit-pro-react");
var actions_1 = require("../../../../redux/reducers/authentication/actions");
var framework_1 = require("../../../../widgets/framework");
var focusableSelectors = "\n  button, a, input, iframe, [tabindex]:not([tabindex=\"-1\"])\n";
var styles = function (theme) {
    var _a;
    return (0, styles_1.createStyles)({
        container: material_kit_pro_react_1.container,
        content: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center'
        },
        dialog: {
            backgroundColor: theme.palette.background.default,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        dialogActions: {
            padding: theme.spacing(2)
        },
        email: {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        button: {
            width: '164px',
            height: '44px'
        },
        register: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: theme.spacing(4)
        },
        primaryText: {
            color: theme.palette.primary.main
        },
        buttonText: {
            color: theme.palette.common.white
        },
        description: {
            maxWidth: '100%'
        },
        resendButtonContainer: { textAlign: 'center' },
        resendButton: {
            '&.MuiButton-containedPrimary.Mui-disabled': {
                backgroundColor: colors_1.default.textSecondaryColor.hex(),
                color: theme.palette.text.disabled
            },
            '&:disabled': {
                backgroundColor: colors_1.default.textSecondaryColor.hex(),
                color: theme.palette.text.disabled
            },
            width: '50%'
        },
        padBottom: {
            paddingBottom: theme.spacing(2)
        },
        close: {
            display: 'flex',
            justifyContent: 'flex-end',
            minHeight: '3rem'
        },
        closeButton: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            overflow: 'hidden',
            marginRight: theme.spacing(1),
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        },
        noPadding: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                padding: 0
            },
            _a)
    });
};
exports.resendActivationSchema = yup.object().shape({
    email: yup
        .string()
        .required()
        .email()
});
var ResendActivationDialog = function (_a) {
    var _b;
    var show = _a.show, onSuccessCallback = _a.onSuccessCallback, closeReactivationDialog = _a.closeReactivationDialog;
    var theme = (0, styles_1.useTheme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var useStyles = (0, styles_1.makeStyles)(styles);
    var classes = useStyles(theme);
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_1.useState)(''), email = _c[0], setEmail = _c[1];
    var _d = (0, react_1.useState)(false), formIsValid = _d[0], setFormIsValid = _d[1];
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_1.sendAccountActivationInstructions)(email));
            onSuccessCallback();
            setEmail(email);
            return [2];
        });
    }); };
    var onNavigate = function (action) { return function () {
        var appNavigate = { action: action };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }; };
    var onEmailChange = function (event) {
        var value = event.target.value;
        var formisValid = exports.resendActivationSchema.isValidSync({ email: value });
        setEmail(value);
        setFormIsValid(formisValid);
    };
    var updateTabIndex = function (disableFocus) {
        var focusableElements = document.querySelectorAll(focusableSelectors);
        focusableElements.forEach(function (el) {
            if (disableFocus) {
                el.setAttribute('tabindex', '-1');
            }
            else {
                el.removeAttribute('tabindex');
                if (el.tagName === 'BUTTON' && el.getAttribute('type') === 'button') {
                    el.setAttribute('tabindex', '0');
                }
            }
        });
    };
    (0, react_1.useEffect)(function () {
        updateTabIndex(show);
        return function () {
            updateTabIndex(false);
        };
    }, [show]);
    return (react_1.default.createElement(Dialog_1.default, { "aria-labelledby": "alert-dialog-slide-title", open: show, className: (0, classnames_1.default)('po-widget-dialog'), PaperProps: {
            className: classes.dialog
        }, onClose: closeReactivationDialog },
        react_1.default.createElement("div", { className: (0, classnames_1.default)((_b = {},
                _b[classes.close] = true,
                _b[classes.noPadding] = true,
                _b)) },
            react_1.default.createElement(IconButton_1.default, { "aria-label": "Close", onClick: closeReactivationDialog, className: classes.closeButton, autoFocus: true },
                react_1.default.createElement(Icon_1.default, null, t('registration.iconClose')))),
        react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-slide-title", disableTypography: true },
                react_1.default.createElement(Typography_1.default, { variant: "h6", component: "h2", align: "center" }, t('registration.resendActivationEmail'))),
            react_1.default.createElement(DialogContent_1.default, { id: "resent-activation-dialog" },
                react_1.default.createElement(Typography_1.default, { variant: "body2", align: 'center', className: classes.padBottom }, t('registration.resendDescription')),
                react_1.default.createElement(TextField_1.default, { label: "Email", type: "email", autoComplete: "email", variant: "filled", fullWidth: true, id: "resendActivationEmail", value: email, onChange: onEmailChange }),
                react_1.default.createElement("div", { className: classes.resendButtonContainer },
                    react_1.default.createElement(Button_1.default, { className: classes.resendButton, size: "large", variant: "contained", fullWidth: true, disabled: !formIsValid, color: "primary", onClick: onSubmit, "aria-label": t('registration.resendActivation') }, t('registration.resendActivation')))),
            react_1.default.createElement("div", { className: classes.register },
                react_1.default.createElement(Typography_1.default, { color: "textPrimary", variant: "body2" }, t('registration.createAccountQuestion')),
                react_1.default.createElement(Button_1.default, { onClick: onNavigate('REGISTER'), "aria-label": t('registration.registerHere') },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.primaryText }, t('registration.registerHere')),
                    react_1.default.createElement(Icon_1.default, { color: "primary" }, "how_to_reg"))))));
};
exports.default = ResendActivationDialog;
//# sourceMappingURL=ResendActivationDialog.js.map